function StatsCards({ stats }) {
  return (
    <section className="kb-stats" aria-label="Article stats">
      {stats.map((item) => (
        <article key={item.id} className="kb-stat-card">
          <p>{item.label}</p>
          <strong className={`kb-stat-card__value kb-stat-card__value--${item.tone}`.trim()}>
            {item.value}
          </strong>
        </article>
      ))}
    </section>
  );
}

export default StatsCards;
